<script lang="ts" setup>
import type {
  EditorialTimelineBlock,
  EditorialTimelineContainerProps,
} from '@design-system/components/Editorial/Timeline/EditorialTimelineContainer.props'
import type { EditorialTimeline } from '@integration-layer/ampliance/schemas/editorial-timeline-schema.localized'
const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialTimeline
}>()

const data = await useComponentResponse<EditorialTimeline>(props)

type AspectRatio = '16/9' | '4/3' | '3/4' | '1/1' | '4/5' | '5/4'

const blocks: EditorialTimelineBlock[] = (data.value?.blocks ?? []).map(
  block => ({
    titleBlock: block.titleBlock as string,
    cards:
      block.cards?.map((card: any) => ({
        media: card.media,
        logo: card.logo,
        location: card.location,
      })) ?? [],
  })
)

const transformedData: EditorialTimelineContainerProps = {
  mediaAspectRatio: data.value?.mediaAspectRatio as AspectRatio,
  blocks: blocks,
  title: data.value?.title,
  description: data.value?.description,
}
</script>

<template>
  <div>
    <EditorialTimelineContainer v-bind="transformedData" />
  </div>
</template>
